// Small wrapper around PostHog capture for billing-modal events.
// Silences failures (feature flag off, posthog not init, quota) so the
// billing flow itself never regresses on an analytics miss.

export function trackBillingAction(posthog, eventName, properties) {
  if (!posthog) return;
  try {
    posthog.capture(eventName, properties);
  } catch { /* ignore */ }
}
